<template>
  <div class="poll">
    <b-container fluid>
      <b-row>
        <b-col class="cont" cols="10">
          <RestaurantPoll/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import RestaurantPoll from "@/components/RestaurantPoll.vue";

export default {
  components: {
    RestaurantPoll
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.cont {
  margin: 50px;
}
</style>
